export default {
  routes: [
    {
      name: 'content',
      path: '/admin/content',
      component: () => import('./views/TheContent.vue'),

    },

    {
      name: 'node',
      path: '/node/:uuid',
      component: () => import('./views/TheNode.vue'),
    },
  ]
}
